/**
 * Le champ `siren` d'une société accepte un SIREN (9 chiffres) ou un SIRET (14 chiffres).
 * Le type (et donc le libellé affiché) est déduit du nombre de chiffres.
 */

export const SIRET_LENGTH = 14;

export type CompanyIdType = 'SIREN' | 'SIRET';

/** Libellé à afficher selon la valeur : SIRET si 14 chiffres, SIREN sinon. */
export const getCompanyIdLabel = (value: string | null | undefined): CompanyIdType =>
  (value ?? '').replace(/\s/g, '').length === SIRET_LENGTH ? 'SIRET' : 'SIREN';

/** Garde uniquement les chiffres, dans la limite d'un SIRET. */
export const sanitizeCompanyId = (value: string): string =>
  value.replace(/\D/g, '').slice(0, SIRET_LENGTH);

/** true si la valeur est un SIREN (9 chiffres) ou un SIRET (14 chiffres). */
export const isValidCompanyId = (value: string): boolean => /^(\d{9}|\d{14})$/.test(value);

/** SIREN (9 premiers chiffres) d'un SIREN ou d'un SIRET, pour les usages qui exigent un SIREN (Stripe). */
export const toSiren = (value: string): string => value.replace(/\s/g, '').slice(0, 9);

/** Libellé d'un champ de saisie : s'adapte à la valeur une fois complète. */
export const getCompanyIdInputLabel = (value: string | null | undefined): string =>
  isValidCompanyId((value ?? '').replace(/\s/g, '')) ? getCompanyIdLabel(value) : 'SIREN / SIRET';
